/*
Import all child theme specific scripts here
*/

//import cards from "./custom/cards.js";
import "./custom/navbar.js"; // Import navbar functionality
// ajax-search.js is enqueued separately in enqueues.php
import "./libs/splide/splide_custom_simple_initialize.js"; // Import and execute team.js
import "./custom/load-more-posts.js"; // Import load more posts functionality
//import "./custom/dual-section.js"; // Import dual section functionality
import "./custom/hero.js"; // Import hero functionality
import "./custom/staff-testimonial.js"; // Import testimonial functionality
import "./custom/trustpilot-reviews.js"; // Import trustpilot carousel functionality
import "./custom/vacancies.js"; // Import vacancies carousel functionality
import "./custom/faqs.js"; // Import FAQs functionality
import "./custom/legals-nav.js"; // Import legals context nav scroll spy
import "./custom/career-form-scroll.js"; // SELWM-18: scroll to top on multi-step form page change
import "./custom/contact-locations.js"; // SELWM-23: tabbed contact locations nav
